import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCalendar,FiUser,FiArrowRight,FiTag}=FiIcons;

const Blog=()=> {
  const blogPosts=[
    {
      title: '5 Branding Trends Shaping South African Businesses in 2024',
      excerpt: 'Discover the latest branding trends that are transforming how South African businesses connect with their audiences and stand out in competitive markets.',
      author: 'Mandla FG Cetywayo',
      date: '2024-03-15',
      category: 'Branding',
      image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=400&fit=crop',
      readTime: '5 min read',
      tags: ['Branding','Trends','South Africa']
    },
    {
      title: 'Why Your Small Business Needs Professional Design',
      excerpt: 'Learn how professional design can transform your small business,increase credibility,and drive more sales in the competitive South African market.',
      author: 'Babalwa Sibiya',
      date: '2024-03-10',
      category: 'Design',
      image: 'https://images.unsplash.com/photo-1542744094-3a31f272c490?w=800&h=400&fit=crop',
      readTime: '7 min read',
      tags: ['Small Business','Design','Growth']
    },
    {
      title: 'The Psychology of Color in African Brand Identity',
      excerpt: 'Explore how color psychology influences consumer behavior and how African brands can leverage cultural color meanings to create deeper connections.',
      author: 'Thandiwe Khedama',
      date: '2024-03-05',
      category: 'Psychology',
      image: 'https://images.unsplash.com/photo-1541701494587-cb58502866ab?w=800&h=400&fit=crop',
      readTime: '6 min read',
      tags: ['Color Psychology','African Design','Brand Identity']
    },
    {
      title: 'Web Design Best Practices for SA E-commerce',
      excerpt: 'Essential web design principles and best practices specifically tailored for South African e-commerce businesses to maximize conversions and user experience.',
      author: 'Sipho Ndlovu',
      date: '2024-02-28',
      category: 'Web Design',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop',
      readTime: '8 min read',
      tags: ['Web Design','E-commerce','UX/UI']
    },
    {
      title: 'Case Study: How We Helped a Startup Secure R5M Funding Through Design',
      excerpt: 'A detailed case study showing how strategic brand design and compelling visual identity helped a South African startup secure major funding.',
      author: 'Mandla FG Cetywayo',
      date: '2024-02-20',
      category: 'Case Study',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=400&fit=crop',
      readTime: '10 min read',
      tags: ['Case Study','Startup','Funding','Success Story']
    },
    {
      title: 'Digital Marketing Strategies for African Brands',
      excerpt: 'Effective digital marketing strategies that resonate with African audiences and drive meaningful engagement across social media platforms.',
      author: 'Thandiwe Khedama',
      date: '2024-02-15',
      category: 'Digital Marketing',
      image: 'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=800&h=400&fit=crop',
      readTime: '9 min read',
      tags: ['Digital Marketing','Social Media','African Markets']
    }
  ];

  const categories=['All','Branding','Design','Web Design','Digital Marketing','Case Study'];
  const [activeCategory,setActiveCategory]=React.useState('All');
  const filteredPosts=activeCategory==='All' ? blogPosts : blogPosts.filter(post=> post.category===activeCategory);

  return (
    <div className="min-h-screen pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 50}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            className="text-center text-white"
          >
            <h1 className="font-poppins font-bold text-4xl md:text-5xl lg:text-6xl mb-6">
              Our <span className="text-purple-600">Blog</span>
            </h1>
            <p className="font-inter text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
              Insights,tips,and inspiration from our creative team. Stay updated with the latest trends in design,branding,and digital marketing.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category)=> (
              <button
                key={category}
                onClick={()=> setActiveCategory(category)}
                className={`px-6 py-3 rounded-full font-inter font-medium transition-all duration-300 ${
                  activeCategory===category
                    ? 'bg-purple-600 text-white shadow-lg'
                    : 'bg-gray-50 text-gray-600 hover:bg-purple-600 hover:text-white'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Post */}
      {filteredPosts.length > 0 && (
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{opacity: 0,y: 50}}
              whileInView={{opacity: 1,y: 0}}
              transition={{duration: 0.8}}
              viewport={{once: true}}
              className="bg-white rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="aspect-w-16 aspect-h-9 lg:aspect-none">
                  <img
                    src={filteredPosts[0].image}
                    alt={filteredPosts[0].title}
                    className="w-full h-64 lg:h-full object-cover"
                  />
                </div>
                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <div className="flex items-center space-x-4 mb-4">
                    <span className="px-3 py-1 bg-purple-600 text-white text-sm font-inter font-medium rounded-full">
                      Featured
                    </span>
                    <span className="px-3 py-1 bg-teal-100 text-teal-600 text-sm font-inter font-medium rounded-full">
                      {filteredPosts[0].category}
                    </span>
                  </div>
                  <h2 className="font-poppins font-bold text-2xl lg:text-3xl text-gray-900 mb-4">
                    {filteredPosts[0].title}
                  </h2>
                  <p className="font-inter text-gray-600 mb-6 leading-relaxed">
                    {filteredPosts[0].excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <div className="flex items-center">
                        <SafeIcon icon={FiUser} className="w-4 h-4 mr-1" />
                        <span>{filteredPosts[0].author}</span>
                      </div>
                      <div className="flex items-center">
                        <SafeIcon icon={FiCalendar} className="w-4 h-4 mr-1" />
                        <span>{new Date(filteredPosts[0].date).toLocaleDateString()}</span>
                      </div>
                      <span>{filteredPosts[0].readTime}</span>
                    </div>
                    <button className="inline-flex items-center text-purple-600 font-inter font-medium hover:text-teal-600 transition-colors duration-200">
                      Read More <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      )}

      {/* Blog Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.slice(1).map((post,index)=> (
              <motion.article
                key={post.title}
                initial={{opacity: 0,y: 50}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className="bg-white rounded-xl overflow-hidden shadow-lg card-hover border border-gray-100"
              >
                <div className="relative">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-purple-600 text-white text-sm font-inter font-medium rounded-full">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-poppins font-semibold text-xl text-gray-900 mb-3 line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="font-inter text-gray-600 mb-4 text-sm leading-relaxed line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {post.tags.map((tag)=> (
                      <span
                        key={tag}
                        className="inline-flex items-center px-2 py-1 bg-gray-50 text-gray-600 text-xs font-inter rounded-md"
                      >
                        <SafeIcon icon={FiTag} className="w-3 h-3 mr-1" />
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="text-xs text-gray-500 space-y-1">
                      <div className="flex items-center">
                        <SafeIcon icon={FiUser} className="w-3 h-3 mr-1" />
                        <span>{post.author}</span>
                      </div>
                      <div className="flex items-center">
                        <SafeIcon icon={FiCalendar} className="w-3 h-3 mr-1" />
                        <span>{new Date(post.date).toLocaleDateString()}</span>
                      </div>
                    </div>
                    <div className="text-xs text-gray-500">
                      {post.readTime}
                    </div>
                  </div>
                  <button className="mt-4 inline-flex items-center text-purple-600 font-inter font-medium hover:text-teal-600 transition-colors duration-200">
                    Read More <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4" />
                  </button>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 50}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="text-center"
          >
            <h2 className="font-poppins font-bold text-3xl md:text-4xl text-white mb-4">
              Stay Updated
            </h2>
            <p className="font-inter text-lg text-gray-100 max-w-2xl mx-auto mb-8">
              Subscribe to our newsletter and get the latest insights,tips,and trends delivered directly to your inbox.
            </p>
            <div className="max-w-md mx-auto">
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 rounded-l-lg border-0 focus:ring-2 focus:ring-purple-600 focus:outline-none"
                />
                <button className="px-6 py-3 bg-purple-600 text-white font-poppins font-semibold rounded-r-lg hover:bg-opacity-90 transition-all duration-300">
                  Subscribe
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{opacity: 0,y: 50}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
          >
            <h2 className="font-poppins font-bold text-3xl md:text-4xl text-white mb-4">
              Ready to Transform Your Brand?
            </h2>
            <p className="font-inter text-lg text-gray-300 max-w-2xl mx-auto mb-8">
              Let's discuss your project and create something amazing together. Get in touch for a free consultation.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center px-8 py-4 bg-purple-600 text-white font-poppins font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105"
            >
              Start Your Project <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Blog;